import { Helmet } from "react-helmet-async";
import { useHostname } from "@/lib/ssr";
import { isNewHomeEnabled } from "@/lib/homeFlag";
import HomeHeader, { type SitePath } from "@/pages/home/HomeHeader";
import HomeFooter from "@/pages/home/HomeFooter";

// The other public pages (pricing, Find your photos, guides, blog, login / register, legal, the web-uploader and
// launch pages, about) in the new site's light look, where the new home is on (staging until launch:
// src/lib/homeFlag.ts). Their own markup is the old dark site's; they keep it, and:
//   - the old header and footer (AppHeader, Footer) render the new site's (HomeHeader, HomeFooter);
//   - <html> carries data-ph-site="light", and src/index.css remaps the old dark theme's colours under it to the
//     site's tokens (white and muted grounds, ink text, amber with ink text, #A6560A for small amber text).
// Where the new home is off (prod) none of this renders, so those pages are unchanged.

/** Whether the public pages use the new site's light look on this deployment. */
export const useSiteLight = (): boolean => isNewHomeEnabled(useHostname());

/** Marks <html> for the light look's CSS (server-rendered, so the first paint is already light). */
export const SiteLightMark = () => (
  <Helmet>
    <html data-ph-site="light" />
  </Helmet>
);

/** The new site's header, fixed to the top as the old header was (the old pages pad their tops for it). */
export const SiteLightHeader = ({ path = "studio" }: { path?: SitePath }) => (
  <>
    <SiteLightMark />
    <div className="fixed inset-x-0 top-0 z-50 max-h-screen overflow-y-auto">
      <HomeHeader path={path} />
    </div>
  </>
);

export const SiteLightFooter = () => (
  <>
    <SiteLightMark />
    <HomeFooter />
  </>
);
